/**
 * 个体户 接口
 *
 *  author： 任竞
 *  date： 2022-11-19 10:14:07
 */


import request from '@/plugins/request';

/**
 * 个体户列表
 * @param query
 */
export function listSupplier(query) {
    return request({
        url: '/economy/supplier/list',
        method: 'get',
        params: query
    })
}


/**
 * 个体户分页
 * @param query
 */
export function pageSupplier(query) {
    return request({
        url: '/economy/supplier/page',
        method: 'get',
        params: query
    })
}

/**
 * 根据id删除个体户
 * @param id
 */
export function delSupplier(id) {
    return request({
        url: '/economy/supplier/' + id,
        method: 'delete'
    })
}

/**
 * 批量删除个体户
 * @param idList
 */
export function batchDeleteSupplier(idList) {
    return request({
        url: '/economy/supplier/batch-delete',
        method: 'delete',
        data: idList
    })
}

/**
 * 添加个体户
 * @param obj
 */
export function addSupplier(obj) {
    return request({
        url: '/economy/supplier',
        method: 'post',
        data: obj
    })
}


/**
 * 修改个体户
 * @param obj
 */
export function updateSupplier(obj) {
    return request({
        url: '/economy/supplier',
        method: 'put',
        data: obj
    })
}


/**
 * 根据id查询个体户
 * @param id
 */
export function getSupplier(id) {
    return request({
        url: '/economy/supplier/get-by-id/' + id,
        method: 'get'
    })
}


/**
 * 查询上传进度
 * @param number
 */
export function getExcelImport(number) {
    return request({
        url: '/economy/supplier/excel/import/' + number,
        method: 'get'
    })
}


/**
 * 修改是否冻结
 * @param obj
 */
export function updateFrozenSupplier(obj) {
    return request({
        url: '/economy/supplier/update-frozen',
        method: 'put',
        data: obj
    })
}

/**
 * 设置开票内容
 * @param obj
 */
export function invoiceContentSupplier(obj) {
    return request({
        url: '/economy/supplier/invoice-content',
        method: 'put',
        data: obj
    })
}

/**
 * 企业数量,个体户数量
 * @returns {*}
 */
export function getNumber() {
    return request({
        url: '/economy/supplier/number',
        method: 'get'
    })
}

/**
 * 个体户开户
 * @param number
 */
export function openSupplierAccount(id) {
    return request({
        url: '/economy/supplier/open-supplier-account/' + id,
        method: 'get'
    })
}


/**
 * 个体户分页
 * @param query
 */
export function incomeExpensesPage(query) {
    return request({
        url: '/economy/supplier/income-expenses-page',
        method: 'get',
        params: query
    })
}

/**
 * 进销存月汇总
 * @param query
 */
export function inOutDepositPage(query) {
    return request({
        url: '/economy/supplier/in-out-deposit-page',
        method: 'get',
        params: query
    })
}

/**
 * 进销存月汇总详情
 * @param query
 */
export function inOutDepositDetailPage(query) {
    return request({
        url: '/economy/supplier/in-out-deposit-detail-page',
        method: 'get',
        params: query
    })
}


/**
 * 个体工商户数量统计
 * @param number
 */
export function supplierQuantityStatistics() {
    return request({
        url: '/economy/supplier/supplier-quantity-statistics',
        method: 'get'
    })
}



/**
 * 百望用户注册
 * @param number
 */
export function fullElectricInvoiceRegister (id) {
    return request({
        url: '/economy/supplier/bw-register/' + id,
        method: 'get'
    })
}



/**
 * 个体工商户状态变更
 * @param number
 */
export function companyStatusChange (id) {
    return request({
        url: '/economy/supplier/company-status-change/' + id,
        method: 'get'
    })
}


/**
 * 百望用户注册
 * @param number
 */
export function signOutWithdraw (id) {
    return request({
        url: '/economy/supplier/sign-out-withdraw/' + id,
        method: 'get'
    })
}

/**
 * 个体户合同
 */
export function getDownloadUrl (id) {
    return request({
        url: `/economy/supplier/getDownloadUrl/${id}`,
        method: 'get'
    })
}


/**
 * 个体户合同
 */
export function getPreviewUrl (param) {
    return request({
        url: `/economy/supplier/getPreviewUrl`,
        method: 'get',
        params: param
    })
}


/**
 * 修改是否冻结
 * @param obj
 */
export function updateFile(obj) {
    return request({
        url: '/economy/supplier/update-file',
        method: 'put',
        data: obj
    })
}




/**
 * 同步数据
 * @param date
 * @returns {*}
 */
export function synchronizeData(params) {
    return request({
        url: '/economy/supplier/synchronize-data',
        method: 'get',
        params: params
    })
}


/**
 * 个体户姓名列表
 * @param query
 */
export function nameList(query) {
    return request({
        url: '/economy/supplier/names',
        method: 'get',
        params: query
    })
}
